/**
 * Share labels across the connect, loading, and results screens so the promised statistics match those
 * displayed.
 */
import type { CalendarScanStats } from "~vue/CalendarFirstOnboarding/types";

export interface StatTile {
    label: string;
    value: string;
}

export const STAT_LABELS = {
    hoursPerWeek: "Hours a week",
    organised: "Meetings you organised",
    backToBack: "Back-to-back meetings",
    standing: "Recurring meetings",
} as const;

export function formatHours(hours: number): string {
    return Number.isInteger(hours) ? `${hours}` : hours.toFixed(1);
}

/**
 * Omit zero-valued tiles because sparse calendars have dedicated explanatory copy; a row of zeros can
 * suggest a failed scan.
 */
export function statTiles(stats: CalendarScanStats | null): StatTile[] {
    if (stats === null) {
        return [];
    }
    const tiles: StatTile[] = [];
    if (stats.hours_per_week > 0) {
        tiles.push({ label: STAT_LABELS.hoursPerWeek, value: formatHours(stats.hours_per_week) });
    }
    if (stats.organized_count > 0) {
        tiles.push({ label: STAT_LABELS.organised, value: `${stats.organized_count}` });
    }
    if (stats.back_to_back_count > 0) {
        tiles.push({ label: STAT_LABELS.backToBack, value: `${stats.back_to_back_count}` });
    }
    if (stats.recurring_series_count > 0) {
        tiles.push({ label: STAT_LABELS.standing, value: `${stats.recurring_series_count}` });
    }
    return tiles;
}
